var _path, _circle, _circle2, _circle3;
var _excluded = ["title", "titleId"];
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }
function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }
import * as React from "react";
function SvgCalendar(_ref, svgRef) {
  var title = _ref.title,
    titleId = _ref.titleId,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    viewBox: "0 0 14 14",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.56245 0.454102C4.3562 0.454102 4.18748 0.62607 4.18748 0.836287V2.05939H3.04373C1.91865 2.05939 1 2.99586 1 4.14245V11.4619C1 12.6087 1.91879 13.545 3.04373 13.545H10.9563C12.0813 13.545 13 12.6085 13 11.4619V4.16156C13 3.01483 12.0812 2.0785 10.9563 2.0785H9.81252V0.855398C9.81252 0.64517 9.64379 0.473213 9.43755 0.473213C9.23129 0.473213 9.06258 0.645181 9.06258 0.855398V2.0785H4.93756V0.855398C4.93756 0.626107 4.76884 0.454136 4.56259 0.454136L4.56245 0.454102ZM10.9562 12.7998H3.04369C2.33116 12.7998 1.7499 12.2074 1.7499 11.4811V5.48025H12.25V11.4811C12.25 12.2073 11.6687 12.7998 10.9562 12.7998H10.9562ZM12.25 4.16163V4.71591H1.74997V4.16177C1.74997 3.43551 2.33119 2.84307 3.04376 2.84307H10.9563C11.6688 2.84307 12.2501 3.43548 12.2501 4.16163H12.25Z",
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.4
  })), _circle || (_circle = /*#__PURE__*/React.createElement("circle", {
    cx: 4,
    cy: 7.5459,
    r: 0.7,
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.6
  })), _circle2 || (_circle2 = /*#__PURE__*/React.createElement("circle", {
    cx: 7,
    cy: 7.5459,
    r: 0.7,
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.6
  })), _circle3 || (_circle3 = /*#__PURE__*/React.createElement("circle", {
    cx: 10,
    cy: 7.5459,
    r: 0.7,
    fill: "currentColor",
    stroke: "currentColor",
    strokeWidth: 0.6
  })));
}
var ForwardRef = /*#__PURE__*/React.forwardRef(SvgCalendar);
export default __webpack_public_path__ + "static/media/calendar.c11a73b8eb35108603dc8af6de80d087.svg";
export { ForwardRef as ReactComponent };